import Vue from 'vue';
import App from './App';
import store from "../../store";

const app = new Vue({
    store,
    render: render => render(App),
});

export default app;

/**
 * @param {string} element
 */
export function renderAdditionalBox(element = 'div.cart-additional-products') {
    const domElement = document.querySelector(element);

    if (!domElement) {
        console.error(`Element ${element} does not exists`);
        return;
    }

    app.$mount(domElement);
}
